module.exports = __webpack_public_path__ + "img/arrow-down.100ce603.svg";